export const getFlatErrorText = (e: { [key: string]: string }): string => {
  const values = Object.values(e); // Extract values from the object
  const flattened = values.flatMap((value) => value.split(' ')); // Flatten and split strings

  return flattened.join(' '); // Join the flattened strings with a space
};
